import React from "react";
import styles from "./footer.module.css";
const Footer = () => {
  return (
    <div className={` d-flex w-100 p-4`}>
      <div className="w-100">
        <div>
          {
            "All trademarks, logos and brand names are the property of their respective owners. "
          }
        </div>
        <div>
          {
            "All company, product and service names used in this website are for identification purposes only."
          }
        </div>
        <div>
          {
            "Use of these names, trademarks and brands does not imply endorsement."
          }
        </div>
        <div
          className={`text-shadow mt-2`}
          style={{ color: "#2348AB", fontSize: "20px" }}
        >
          {"Copyright © 2024 Escrowstack Pvt Ltd, All Rights Reserved"}
        </div>
      </div>
      <div className="w-100 d-flex justify-content-center align-items-end">
        <div className="pb-1 d-flex align-items-center">Protected by</div> &nbsp;
        {/* Protected by &nbsp; */}
        <img
          className={`${styles.footerIcon}`}
          alt=""
          // src="/escrowstack-logos-27@2x.png"
          src="/Group 202.svg"
          width={108}
          height={22}
          loading="lazy"
        />{" "}
        {/* &nbsp; Monitored by &nbsp; */}
        <div className="pb-1">Monitored by</div> &nbsp;
        <img
          className={`${styles.footerIcon}`}
          alt=""
          // src="/escrowstack-logos-27@2x.png"
          src="/universal.svg"
          loading="lazy"
          width={108}
          height={22}
        />
        {/* &nbsp; &nbsp; Powered by &nbsp; */}
        <div className="pb-1">Powered by</div> &nbsp;
        <img
          alt=""
          // src="/escrowstack-logos-27@2x.png"
          src="/Escrowstack_logos 28.svg"
          loading="lazy"
          width={30}
        />
      </div>
    </div>
  );
};

export default Footer;
